import axios from "axios";
import { baseURL } from "@/general";
axios.defaults.baseURL = baseURL;
import {
  userLogin,
  validaAvisoPrivacidad,
  confirmaAvisoPrivacidad,
  resetPassword,
  verificaAcceso,
  getListaInscritos,
  getGruposProfesor,
  saveCalificaciones,
  changePassword,
} from "@/modules/profesor/helpers/services";

export const verifyUser = async ({ commit }, values) => {
  const { data } = await userLogin(values);
  if (Object.keys(data).length !== 0) {
    return data;
  }
};


export const obtenAvisoPrivacidad = async ({ commit }, values) => {
    const { data } = await validaAvisoPrivacidad(values);
    if (Object.keys(data).length !== 0) {
      return data;
    }
  };


  export const aceptaAvisoPrivacidad = async ({ commit }, values) => {
    const { data } = await confirmaAvisoPrivacidad(values);
    if (Object.keys(data).length !== 0) {
      return data;
    }
  };

  export const restablecerPassword = async ({ commit }, values) => {
    const { data } = await resetPassword(values);
    if (Object.keys(data).length !== 0) {
      return data;
    }
  };

  export const verificaSesion = async ({ commit }, values) => {
    const { data } = await verificaAcceso(values);
    if (Object.keys(data).length !== 0) {
      return data;
    }
  };


  export const traeListaInscritos = async ({ commit }, values) => {
    const { data } = await getListaInscritos(values);
    if (Object.keys(data).length !== 0) {
      return data;
    }
  };

  export const traeGruposProfesor = async ({ commit }, values) => {
    const { data } = await getGruposProfesor(values);
    if (Object.keys(data).length !== 0) {
      return data;
    }
  };


  export const guardaCalificaciones = async ({ commit }, values) => {
    const { data } = await saveCalificaciones(values);
    if (Object.keys(data).length !== 0) {
      return data;
    }
  };

  export const cambiarPassword = async ({ commit }, values) => {
    const { data } = await changePassword(values);
    if (Object.keys(data).length !== 0) {
      return data;
    }
  };


  